var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd1c34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc162c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d4bc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073da6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd64d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcd036"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 5.333333h16v6.095238h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v5.333333h-16z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.61904762 5.71428571-7.61904762 5.71428569z",
    fill: "url(#a)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.58975731 6.47235684-.65201147 1.00169941.24727471-1.16938793c-.03979103-.03250126-.07623523-.06894546-.10873649-.10873649l-1.16938793.24727471 1.00169941-.65201147c-.00253529-.02529227-.00383364-.0509492-.00383364-.07690936s.00129835-.05161708.00383364-.07690935l-1.00169941-.65201147 1.16938793.24727471c.03250126-.03979103.06894546-.07623523.10873649-.10873649l-.24727471-1.16938793.65201147 1.00169941c.02529227-.00253529.0509492-.00383364.07690936-.00383364s.05161708.00129835.07690935.00383364l.65201147-1.00169941-.24727471 1.16938793c.03979103.03250126.07623524.06894546.10873649.10873649l1.16938793-.24727471-1.00169941.65201147c.00253529.02529227.00383364.05094919.00383364.07690935s-.00129835.05161709-.00383364.07690936l1.00169941.65201147-1.16938793-.24727471c-.03250125.03979103-.06894546.07623523-.10873649.10873649l.24727471 1.16938793-.65201147-1.00169941c-.02529227.00253529-.05094919.00383364-.07690935.00383364s-.05161709-.00129835-.07690936-.00383364zm3.1245284-.37711874c-.21039418 0-.38095238-.1705582-.38095238-.38095239 0-.21039418.1705582-.38095238.38095238-.38095238.21039419 0 .38095239.1705582.38095239.38095238 0 .21039419-.1705582.38095239-.38095239.38095239zm-4.57142857-3.80952381c-.21039418 0-.38095238-.1705582-.38095238-.38095239 0-.21039418.1705582-.38095238.38095238-.38095238.21039419 0 .38095238.1705582.38095238.38095238 0 .21039419-.17055819.38095239-.38095238.38095239zm0 7.61904761c-.21039418 0-.38095238-.17055817-.38095238-.38095238s.1705582-.38095238.38095238-.38095238c.21039419 0 .38095238.17055817.38095238.38095238s-.17055819.38095238-.38095238.38095238z",
    fill: "url(#e)",
    mask: "url(#f)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/PH.21456fcbfd3ec9b4043dd81e43cef816.svg";
export { ForwardRef as ReactComponent };